import Typography from '@mui/material/Typography'
import Template from '../../components/layout/Template'

const TenantError = () => {
  return (
    <Template>
      <Typography align='center' variant='h3' className='text-muted uppercase'>Tenant invalid</Typography> 
    </Template>
  )
}

export default TenantError